'use client';

import Link from '@eliadmin/core/src/components/link';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Button } from '../ui/button';

// Keep only translated contact UI on the client, not the entire FAQ dataset.
export function FAQContactCard({ className }: { className?: string }) {
  const { t } = useTranslations();
  return (
    <div
      className={cn(
        'col-span-1 flex w-full flex-col items-start justify-start gap-4 border border-border p-4 sm:gap-5 sm:p-5 lg:gap-6 lg:p-6',
        className,
      )}
    >
      <div className="flex w-full flex-col items-start justify-start gap-2">
        <h3 className="font-heading text-xl font-medium text-black">{t('text3452')}</h3>
        <p className="tracking-tight">{t('text3453')}</p>
      </div>
      <Button asChild variant="dark" className="h-[52px] sm:h-14 lg:h-[60px]">
        <Link prefetch={false} href={ROUTES.CONTACT()}>
          {t('text1153')}
        </Link>
      </Button>
    </div>
  );
}
